import * as React from "react";
function SvgIcArrowDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 16.002L12 20l7-3.998-.373-.639-6.254 3.572V4h-.746v14.935l-6.254-3.572-.373.639z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcArrowDown;
